import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { usePwdPattern } from '../../utils/pwdPattern';

/**
 * PasswordConfirmFields component.
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.submitLabel - The submit label.
 * @param {boolean} props.loading - The loading state.
 * @returns {JSX.Element} The PasswordConfirmFields component.
 */
const PasswordConfirmFields = ({ submitLabel, loading }) => {
  const { t } = useTranslation();

  return (
    <>
      <Form.Item
        name="password"
        rules={[
          { required: true, message: t('login.pwdMissing') },
          ...usePwdPattern()
        ]}
        hasFeedback
      >
        <Input.Password
          prefix={
            <LockOutlined style={{ color: 'var(--textColorSecondary)' }} />
          }
          placeholder={t('login.password')}
        />
      </Form.Item>
      <Form.Item
        dependencies={['password']}
        hasFeedback
        name="confirm"
        rules={[
          {
            required: true,
            message: t('login.pwdMissing')
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(t('login.pwdNotMatching'));
            }
          })
        ]}
      >
        <Input.Password
          prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
          placeholder={t('login.confirmPassword')}
        />
      </Form.Item>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: '100%' }}
          loading={loading}
        >
          {submitLabel}
        </Button>
      </Form.Item>
    </>
  );
};

PasswordConfirmFields.propTypes = {
  submitLabel: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired
};

export default PasswordConfirmFields;
